<template>
  <div class="bridge-signing-view container fluid">
    <v-card>
      <Securities />
    </v-card>
  </div>
</template>

<script>
import { Securities } from '@/components/payoutsAndTaxes';

export default {
  name: 'SecuritiesView',
  components: {
    Securities,
  },
  data() {
    return {};
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.dispatch('fetchPatSecurityAll');
      this.$store.dispatch('fetchSecurityTypes');
    },
  },
};
</script>

<style lang="scss">
.bridge-signing-view {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/payoutsAndTaxes/securities/SecuritiesView.vue